import React, { createContext } from 'react';
import { Redirect, Route } from 'react-router-dom';
import Cookies from 'js-cookie'

import {
  Nav
} from 'components/layout';

const UserContext = createContext(undefined);

const AuthenticatedRoute = ({ component: Component, ...routeProps }) => {

  const authCookie = Cookies.get('auth');
  const userCookie = Cookies.get('user');

  if (authCookie && userCookie) {
    const user = JSON.parse(userCookie);
    return (
      <UserContext.Provider value={{ user }}>
        <Route {...routeProps}>
          <Nav />
          <Component />
        </Route>
      </UserContext.Provider>
    )
  } else {
    return <Redirect to='/login' />
  }
};

export { AuthenticatedRoute, UserContext };
